import {FetchHandler} from "../../../../../infrastructure/handlers/fetch-handler";
import {FooterModuleState} from "../models/footer-module.state";
import {FooterDomainService} from "../../../../../domain/footer/services/footer.domain-service";
import {FooterRequestParams} from "../../../../../domain/footer/models/footer.request-params";
import {FooterModuleController} from "../footer-module.controller";
import {FooterDataSource} from "../../../../../domain/footer/models/footer.data-source";
import {runInAction} from "mobx"
import {SPORT_TYPES} from "../../../../../core/app/consts";

export class FooterModuleFetchHandler extends FetchHandler {
  controller: FooterModuleController;
  state: FooterModuleState;

  static injectables = [FooterDomainService];

  onLoaded() {
    super.onLoaded();

    this.controller.props.sportTypeId && this.action();
  }

  get requestParams() {
    let sportTypeId: Number = this.controller.props.sportTypeId;
    if(sportTypeId === SPORT_TYPES.onTv){
      sportTypeId = SPORT_TYPES.football
    }
    const requestParams: FooterRequestParams = new FooterRequestParams(sportTypeId);

    return requestParams;
  }

  async action(params) {
    const dataSource: FooterDataSource = await this.fetch();

    runInAction(() => {
      this.state.description = dataSource?.description || this.state.terms.FOOTER_DESCRIPTION;
    })

    return dataSource;
  }

  onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps);

    const isSportTypeIdChanged: Boolean = prevProps?.sportTypeId !== nextProps?.sportTypeId;

    isSportTypeIdChanged && this.action();
  }
}
